import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface smsPurchaseState {
    list: any,
  }
  
const initialState:smsPurchaseState = {
    list:undefined,
}

export const smsPurchaseSlice = createSlice({
    name:"smsPurchaseList",
    initialState,
    reducers:{
        UpdateSMSPurchaseList: (state,action) => {
            state.list = action.payload.smsPurchaseList;
        },
        AddSMSPurchase: (state,action) => {
            state.list = undefined;
        },
        EditSMSPurchase: (state,action) => {
            state.list = undefined;
        },
        RemoveSMSPurchase: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateSMSPurchaseList,AddSMSPurchase,EditSMSPurchase,RemoveSMSPurchase} = smsPurchaseSlice.actions

export const selectsmsPurchaseList = (state: RootState) => state.labList

export default smsPurchaseSlice.reducer;